import type { Except } from '@festina-life/core'

import type { NumberInputProps } from '../numberInput/NumberInput'
import { RawNumberInput } from '../numberInput/RawNumberInput'

export type RawDoubleInputProps = Except<NumberInputProps, 'wrapperProps'>

export const DEFAULT_DOUBLE_DECIMAL_SCALE = 8

export const RawDoubleInput = ({
  decimalScale = DEFAULT_DOUBLE_DECIMAL_SCALE,
  ...restProps
}: RawDoubleInputProps) => (
  <RawNumberInput decimalScale={decimalScale} {...restProps} />
)
